/** Shell geometry from the Figma Desktop v3 / Mobile v3 frames. */
export const TOP_BAR_HEIGHT = { xs: 56, md: 64 } as const;
export const SIDE_NAV_WIDTH = 240;
export const BOTTOM_TABS_HEIGHT = 60;
/** Widest content column (D04: 1104px between the nav and the right edge). */
export const CONTENT_MAX_WIDTH = 1104;
export const SAFE_AREA_BOTTOM = "env(safe-area-inset-bottom, 0px)";
